/* Pre-sell pages (step 14). Hand-written, not generated.
   1. The first screen per ad angle is set before the first paint by the ev-hero snippet (theme/snippets/ev-hero.liquid, rendered
      in the layout's <head>; rule in kit/knowledge/landing-pages/copy-rules.md §2), which writes the angle shown on
      <html data-angle>; this script reads it for its events. Pages built before 2026-10-19 swapped single elements by concept code
      instead ([data-c04] when C04 is anywhere in the ad name, [data-f-<format>] when "_<format>_" is): kept below for them only.
   2. Every link to the product page (a[data-pdp]) keeps the visitor's whole query string (UTMs, ad_name, fbclid, Whop click ids),
      except variant (the link sets its own).
   3. A click on one of those links publishes a custom Shopify analytics event (lp_cta_click) with the page, the
      link position, the angle shown and the concept, for the page → PDP click-through (target ≥ 35 %).
   4. Sticky bar ([data-sticky-bar]): shown once [data-sticky-start] is reached, hidden while [data-sticky-stop]
      (the offer box) is on screen.
   5. Quiz (#quiz, optional): one .qstep at a time, each answer a <button data-t="X">, a belief card a <button data-card> (moves on, no tag), the anchor
      question's answers <button data-k="N"> (no tag: shows the .qanchor[data-k=N] line under the result); the most frequent tag shows the .qres
      with data-r="X" (ties go to the tag in data-tie on #quiz, else the first answer's tag); #qbar width = progress; #qback goes
      back; .qnext shows with the result. Nothing is stored; each answered step is published as lp_quiz_step (drop-off per question) and the result as lp_quiz_result. */
(function () {
  var q = new URLSearchParams(location.search);
  var angle = document.documentElement.getAttribute('data-angle') || 'default';
  // pages built before 2026-10-19 only: the concept code and the format word in the ad name (ad_name, utm_term, utm_content)
  var uc = [q.get('ad_name'), q.get('utm_term'), q.get('utm_content')].filter(Boolean).join(' ').toLowerCase();
  var m = uc.match(/(?:^|[_\/\s])(c\d\d)(?=[a-z]?(?:[_\-\s]|$))/);
  var key = m ? m[1] : null;
  if (key) document.querySelectorAll('[data-' + key + ']').forEach(function (el) { el.innerHTML = el.getAttribute('data-' + key); });
  document.querySelectorAll('*').forEach(function (el) {
    for (var a = 0; a < el.attributes.length; a++) {
      var n = el.attributes[a].name;
      if (n.indexOf('data-f-') === 0 && uc.indexOf('_' + n.slice(7) + '_') > -1) { el.innerHTML = el.attributes[a].value; break; }
    }
  });

  var pass = [];
  q.forEach(function (v, k) { if (k !== 'variant') pass.push(encodeURIComponent(k) + '=' + encodeURIComponent(v)); });
  var page = document.body.getAttribute('data-lp') || 'lp';
  document.querySelectorAll('a[data-pdp]').forEach(function (a, i) {
    if (pass.length) a.href += (a.href.indexOf('?') > -1 ? '&' : '?') + pass.join('&');
    a.addEventListener('click', function () {
      try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('lp_cta_click', { page: page, link: i + 1, angle: angle, concept: key || 'default' }); } catch (e) {}
    });
  });

  var bar = document.querySelector('[data-sticky-bar]'), start = document.querySelector('[data-sticky-start]'), stop = document.querySelector('[data-sticky-stop]');
  if (bar && start) {
    var tick = function () {
      var past = start.getBoundingClientRect().top < window.innerHeight * 0.4;
      var r = stop ? stop.getBoundingClientRect() : null;
      var over = r && r.top < window.innerHeight && r.bottom > 0;
      bar.classList.toggle('on', past && !over);
    };
    window.addEventListener('scroll', tick, { passive: true });
    tick();
  }

  var box = document.getElementById('quiz');
  if (box) {
    var steps = box.querySelectorAll('.qstep'), qbar = document.getElementById('qbar'), back = document.getElementById('qback'), picks = [], kpick = null, i = 0;
    var show = function () {
      steps.forEach(function (s, k) { s.classList.toggle('on', k === i); });
      if (qbar) qbar.style.width = (i / steps.length * 100) + '%';
      if (back) back.classList.toggle('on', i > 0 && i < steps.length);
    };
    var finish = function () {
      var tags = picks.filter(Boolean), n = {}; tags.forEach(function (t) { n[t] = (n[t] || 0) + 1; });
      var r = box.getAttribute('data-tie') || tags[0];
      Object.keys(n).forEach(function (t) { if (n[t] > (n[r] || 0)) r = t; });
      box.querySelectorAll('.qres').forEach(function (el) { el.classList.toggle('on', el.getAttribute('data-r') === r); });
      box.querySelectorAll('.qanchor').forEach(function (el) { el.classList.toggle('on', el.getAttribute('data-k') === kpick); });
      var nx = box.querySelector('.qnext'); if (nx) nx.classList.add('on');
      if (qbar) qbar.style.width = '100%'; if (back) back.classList.remove('on');
      try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('lp_quiz_result', { page: page, result: r, anchor: kpick || 'none', angle: angle, concept: key || 'default' }); } catch (e) {}
    };
    box.addEventListener('click', function (e) {
      var b = e.target.closest('.qstep button');
      if (b) { e.preventDefault(); var t = b.getAttribute('data-t'), k = b.getAttribute('data-k'); picks[i] = t; if (k !== null) kpick = k; try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('lp_quiz_step', { page: page, step: i + 1, screen: steps[i].getAttribute('data-q') || String(i + 1), answer: t || k || 'next', angle: angle, concept: key || 'default' }); } catch (e2) {} i++; if (i < steps.length) show(); else { steps.forEach(function (s) { s.classList.remove('on'); }); finish(); } return; }
      if (e.target === back) { e.preventDefault(); if (i > 0) { i--; show(); } }
    });
    show();
  }
})();
